export default __webpack_public_path__ + "static/media/bg-pattern-hero-home.7ee19920.svg";